<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>Planillas de Desempeño - Auditores</h6>
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Filtro por Año" dense v-model="filtroperiodo">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-btn tile color="success" @click="cargarListados()">
                                <v-icon left> mdi-magnify </v-icon>
                                Buscar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-data-table dense :headers="headers" :items="listado" locale="es-ar" class="elevation-1"
                :items-per-page="200" :footer-props="{
                    itemsPerPageText: 'planillas por página',
                }">

            </v-data-table>
        </v-app>
    </div>
</template>

<script>
import moment from "moment";
import axios from "../../../axios-auth";

export default {

    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        filtroestado: "Todos",
        filtroperiodo: moment().subtract(1, 'Year').format("YYYY"),
        listado: [],
        headers: [
            {
                text: "Legajo",
                align: "center",
                sortable: false,
                value: "legajo",
            },
            { text: "Nombre", value: "nombre", sortable: false },
            { text: "Calificación", value: "puntajepreseval", sortable: false },
            { text: "Observaciones", value: "observ", align: "center", sortable: false },
        ],
    }),

    computed: {
        show: {
            get() {
                // this.cargarListados();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {

        cargarListados() {
            this.vaciarModels();

            const periodo = this.filtroperiodo;
            let self = this;

            axios
                .get("/RRHH/ListadoDesempenioAuditores?", {
                    params: {
                        filtroperiodo: periodo,
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        vaciarModels() {
            this.listado = [];
        },
    },
};
</script>